export default __webpack_public_path__ + "static/media/index-02.14a17edb.jpg";